import { api } from 'app/api';

export const sendNewPtAddress = async (params) => {
  // return await axios.get(`mock/nwpt-addr-snd.json`);
  return await api.post(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/nwpt-addr-snd`, params);
};

export const sendNewPtAddressCommon = async (params) => {
  return await api.post(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/front/common/process`, params);
};

